var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8473_11142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8001 31.7697L44.8801 21.9897L52.8001 12.2097C54.1801 10.4997 54.4501 8.18973 53.5201 6.20973C52.5901 4.22973 50.6101 2.96973 48.3901 2.96973H11.3101C8.19014 2.96973 5.64014 5.51973 5.64014 8.63973V53.9697C5.64014 55.6197 6.99014 56.9697 8.64014 56.9697C10.2901 56.9697 11.6401 55.6197 11.6401 53.9697V40.9797H48.3901C50.6101 40.9797 52.5601 39.7497 53.5201 37.7397C54.4801 35.7597 54.2101 33.4497 52.8001 31.7397V31.7697ZM11.6401 35.0097V8.99973H47.6701L38.6701 20.0997C37.7701 21.2097 37.7701 22.7697 38.6701 23.8797L47.6701 34.9797H11.6401V35.0097Z",
    fill: "#FF6711"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8473_11142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagWarningIcon);
export default __webpack_public_path__ + "static/media/flag_warning_icon.a8c3815ddd93e5c1d66525a53e986ce2.svg";
export { ForwardRef as ReactComponent };